const subscriptions :{[x:string]:{callback:Function}[]} = {};

export function publish( topic :string,  ... args :any[]) {
  if( !subscriptions[ topic ] ) {
    return;
  }
  var e;
  for(var sub of subscriptions[topic]){
    try{
      sub.callback.apply(sub,args)
    }catch(ex){
      e = e || ex;
    }
  }
  if(e) throw e;
}
export function publishAsync( topic :string,  ... args :any[]) {
  setTimeout(()=>publish(topic, ... args),0)
}

export function subscribe( topic:string, callback:Function|{callback:Function}) {
  var topics = topic.split( /\s/ );
  if(topics.length>1){
    for(var i=0;i<topics.length;i++){
      subscribe(topics[i],callback);
    }
    return;
  }
  const subscription = typeof callback==='function'?{callback}:callback;
  if(subscriptions[topic]===undefined){
    subscriptions[topic] = []
  }
  subscriptions[topic].push(subscription)
}

export function unsubscribe( topic:string, callback:Function|{callback:Function}) {
  var topics = topic.split( /\s/ );
  if(topics.length>1){
    for(var i=0;i<topics.length;i++){
      unsubscribe(topics[i],callback);
    }
    return;
  }
  const subscription = typeof callback==='function'?{callback}:callback;
  subscriptions[topic] = subscriptions[topic].filter(sub=>sub.callback!==subscription.callback)
}